import React from "react";

const MobileSectionSeperator = ({ order, margin, className }) => {
  return (
    <div
      className={`mobileSectionSeperator ${className ?? ""}`}
      style={{ order: order ?? "", margin: margin ?? "" }}
    ></div>
  );
};

export default MobileSectionSeperator;
